import type { UserProfile as UserProfileModel } from '@/adapters/apiv1.g';
import type { UserProfile } from '@/types/core/user';
import type { UUID } from '@/utils/uuid';

export function extractUserProfile(model: UserProfileModel): UserProfile {
  return {
    userId: model.user_id as UUID | undefined,
    email: model.email,
    firstName: model.first_name,
    lastName: model.last_name,
    name: model.name,
    photoUrl: model.photo_url,
  };
}
